import {useSelector} from 'react-redux';

/**
 * The current employee's id.
 * @returns {string|undefined} The current employee's id.
 */
export const useEmployeeId = () => useSelector(state => state.user.employee.id);
